var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Jump"},[_c('div',{staticClass:"box"},[_c('a-spin',{attrs:{"tip":"Loading..."}},[_c('div',{staticClass:"spin-content"},[_vm._v(" 我的描述文案是自定义的。。。 ")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }